import { experimentsService } from '@wix/cashier-common/dist/src/utils/experimentsService';
import { Environment } from '../../types/Environment';
import { Experiment } from '../../types/Experiment';

export const sentryConfig = {
  dsn: 'https://82c7c658322648708fc94ea5e6716e7a@sentry.wixpress.com/136',
  maxBreadcrumbs: 50,
  environment:
    process.env.NODE_ENV === 'production' ? Environment.Prod : Environment.Dev,
};

export const isErrorReportingEnabled = (): boolean =>
  !experimentsService.isExperimentEnabled(Experiment.SuspendErrorReporting);
